import React from 'react';

const Divider = ({ width, color }) => {
  return (
    <hr
      style={{
        width: `${width}px`,
        borderColor: color,
        borderStyle: 'solid',
        borderWidth: '1px'
      }}
    />
  );
};

export default Divider;
